import React from 'react';
import './Process.css';

import { Heading, ProcessStep } from '../../../components';
import { process } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper';
 
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles  
import 'swiper/css'; 
import 'swiper/css/pagination';



const Process = () => { 

  return (
    <section className='process'>

      {/* Section heading */}
      <Heading title={'Our Process'} subTitle={'How We Drive'} />

      {/* Swiper Component for Process Steps */}
      <Swiper

        modules={[Autoplay]} // Enable Autoplay
        spaceBetween={10}  // Space between slides
        loop={true}  // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          991: { slidesPerView: 3 }, // 3 slides for larger screens
        }} 

        >
        {/* Map over the process array to render each process step */}
        {process.map((step) => {

          return (
            <SwiperSlide key={step.id}>

              <ProcessStep step={step} /> {/* Render ProcessStep Component */}

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Process;